import AuthService from 'core/auth.service';

// --- Helper Methods (String) ---
/**
 * Formats the string as a currency value with symbol, commas,
 * and optional decimal places.
 */
export const toCurrency = (value, decimals = 2, hideSymbol = false) => {
  if (value == null) return '';
  const number = Number(value);
  if (isNaN(number)) return value;

  // Get the currencyCode dynamically each time
  const currencyCode = AuthService.getUserIdentity()?.currencyCode || 'USD';

  // Base options for decimals and commas
  const options = {
    minimumFractionDigits: 0, // Allows dropping trailing zeros (12.00 -> 12)
    maximumFractionDigits: decimals, // Capped at the requested max decimals (12.152 -> 12.15)
  };

  // Conditionally add currency styling
  if (!hideSymbol) {
    options.style = 'currency';
    options.currency = currencyCode;
  } else {
    options.style = 'decimal';
  }

  return number.toLocaleString('en-US', options);
};

// Simple standard email regex validation
export const validateEmailAddress = (emailString) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(emailString);
};
